module.exports = __webpack_public_path__ + "static/img/accidental_cyberpic.5ce889a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/compressed/drawing_painting/accidental_cyberpic.jpg
// module id = 2t6i
// module chunks = 1